var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3135_46409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.31309 2.17723C-0.201575 4.78923 0.313091 7.5639 0.313091 15.9932C0.313091 22.9932 -0.908242 30.0106 5.48376 31.6626C7.47976 32.1759 25.1651 32.1759 27.1584 31.6599C29.8198 30.9732 31.9851 28.8146 32.2811 25.0506C32.3224 24.5252 32.3224 7.47057 32.2798 6.93457C31.9651 2.92523 29.4971 0.614566 26.2451 0.146566C25.4998 0.0385658 25.3504 0.00656577 21.5264 -0.000100896C7.96242 0.00656577 4.98909 -0.597434 2.31309 2.17723Z",
    fill: "url(#paint0_linear_3135_46409)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3112 4.18523C11.4699 4.18523 6.87255 3.75456 5.11655 8.26123C4.39121 10.1226 4.49655 12.5399 4.49655 16.0012C4.49655 19.0386 4.39921 21.8932 5.11655 23.7399C6.86855 28.2492 11.5032 27.8172 16.3085 27.8172C20.9445 27.8172 25.7245 28.2999 27.5019 23.7399C28.2285 21.8599 28.1219 19.4786 28.1219 16.0012C28.1219 11.3852 28.3765 8.40523 26.1379 6.1679C23.8712 3.90123 20.8059 4.18523 16.3059 4.18523H16.3112ZM15.2525 6.31456C25.3512 6.29856 26.6365 5.1759 25.9272 20.7719C25.6752 26.2879 21.4752 25.6826 16.3125 25.6826C6.89921 25.6826 6.62855 25.4132 6.62855 15.9959C6.62855 6.46923 7.37521 6.3199 15.2525 6.3119V6.31456ZM22.6179 8.2759C21.8352 8.2759 21.2005 8.91056 21.2005 9.69323C21.2005 10.4759 21.8352 11.1106 22.6179 11.1106C23.4005 11.1106 24.0352 10.4759 24.0352 9.69323C24.0352 8.91056 23.4005 8.2759 22.6179 8.2759ZM16.3112 9.93323C12.9605 9.93323 10.2445 12.6506 10.2445 16.0012C10.2445 19.3519 12.9605 22.0679 16.3112 22.0679C19.6619 22.0679 22.3765 19.3519 22.3765 16.0012C22.3765 12.6506 19.6619 9.93323 16.3112 9.93323ZM16.3112 12.0626C21.5179 12.0626 21.5245 19.9399 16.3112 19.9399C11.1059 19.9399 11.0979 12.0626 16.3112 12.0626Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3135_46409",
    x1: 2.37445,
    y1: 29.956,
    x2: 32.1151,
    y2: 4.21587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3135_46409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.313477)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.6dcf10a49feab747e8ec1914d5bcdedf.svg";
export { ForwardRef as ReactComponent };